import type {
    CategoryType,
    GetPartnersDataParamsType,
    PrismicPartnersListType,
} from '@/components/sections/SectionShopSearch/SectionShopSearch.types';

import { env } from '@/env.mjs';

const apiUrl =
    env.NEXT_PUBLIC_APP_COUNTRY === 'RO'
        ? env.NEXT_PUBLIC_CONTENT_API_URL_RO
        : env.NEXT_PUBLIC_CONTENT_API_URL_PL;

export const getPartnersData = async ({
    page,
    limit,
    queryString,
    categoryName,
    dateFrom,
    dateTo,
    orderBy,
    orderDirection,
}: GetPartnersDataParamsType): Promise<PrismicPartnersListType> => {
    const params = new URLSearchParams({
        'filter[isHiddenOnShopList]': '0',
    });

    const options = {
        'pagination[page]': page,
        'pagination[limit]': limit,
        'filter[query]': queryString,
        'filter[categories][]': categoryName,
        'filter[dateFrom]': dateFrom,
        'filter[dateTo]': dateTo,
        'order[by]': orderBy,
        'order[direction]': orderDirection,
    };

    Object.entries(options).forEach(([key, value]) => {
        if (value) params.append(key, value.toString());
    });

    const response = await fetch(`${apiUrl}/merchants?${params.toString()}`);

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
};

export const getCategoriesData = async ({
    categoryName,
    groupName,
}: {
    categoryName: string;
    groupName: string;
}): Promise<CategoryType> => {
    const params = new URLSearchParams();

    const options = {
        'filter[groups][]': groupName,
        'filter[category]': categoryName,
    };

    Object.entries(options).forEach(([key, value]) => {
        if (value) params.append(key, value);
    });

    const response = await fetch(`${apiUrl}/categories?${params.toString()}`);

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
};
